import { render, staticRenderFns } from "./PageContent.vue?vue&type=template&id=ab8f6cc6&scoped=true&"
import script from "./PageContent.vue?vue&type=script&lang=ts&"
export * from "./PageContent.vue?vue&type=script&lang=ts&"
import style0 from "./PageContent.vue?vue&type=style&index=0&id=ab8f6cc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab8f6cc6",
  null
  
)

export default component.exports